import {APP_INITIALIZER, NgModule, Provider} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayModule } from 'primeng/overlay';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TreeModule } from 'primeng/tree';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NovoAmbienteDialogComponent } from './components/ambiente/novo-ambiente-dialog/novo-ambiente-dialog.component';
import { NovabaseComponent } from './components/base/novabase/novabase.component';
import { ContratoComponent } from './components/contrato/contrato/contrato.component';
import { HeaderComponent } from './components/header/header.component';
import { ListarprocessosComponent } from './components/listarprocessos/listarprocessos.component';
import { AtendimentoDialogComponent } from './components/painelinsumo/atendimento-dialog/atendimento-dialog.component';
import { CancelarRemessaComponent } from './components/painelinsumo/cancelar-remessa/cancelar-remessa.component';
import { PosicaoDialogComponent } from './components/painelinsumo/posicao-dialog/posicao-dialog.component';
import { PerfilDialogComponent } from './components/perfil-dialog/perfil-dialog.component';
import { RedefinicaoSenhaDialogComponent } from './components/redefinicao-senha-dialog/redefinicao-senha-dialog.component';
import { TagStatusComponent } from './components/tag-status/tag-status.component';
import { UsuarioComponent } from './components/usuario/usuario.component';
import { httpHeaderInterceptor } from './config/http-header.interceptor';
import { HomeComponent } from './home/home.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { DefinicaoSenhaComponent } from './login/definicao-senha/definicao-senha.component';
import { LoginComponent } from './login/login.component';
import { ClienteformComponent } from './pages/administracao/clientes/clientes/clienteform/clienteform.component';
import { ClientesComponent } from './pages/administracao/clientes/clientes/clientes.component';
import { BasesComponent } from './pages/administracao/infra/bases/bases.component';
import { ServidoresComponent } from './pages/administracao/infra/servidores/servidores.component';
import { PerfilComponent } from './pages/administracao/perfil/perfil.component';
import { PerfilformComponent } from './pages/administracao/perfil/perfilform/perfilform.component';
import { UsuariosComponent } from './pages/administracao/usuarios/usuarios.component';
import { ContratosComponent } from './components/contrato/contratos/contratos.component';
import { PainelcontratoComponent } from './pages/integracoes/contratos/painelcontrato/painelcontrato.component';
import { ProcessamentocontratoComponent } from './components/contrato/processamentocontrato/processamentocontrato.component';
import { TmadialogComponent } from './pages/integracoes/contratos/tma/tmadialog/tmadialog.component';
import { TmalistComponent } from './pages/integracoes/contratos/tma/tmalist/tmalist.component';
import { CustoconsumoComponent } from './pages/integracoes/custos/custoconsumo/custoconsumo.component';
import { CustodepreciacaoComponent } from './pages/integracoes/custos/custodepreciacao/custodepreciacao.component';
import { CustodespesageralComponent } from './pages/integracoes/custos/custodespesageral/custodespesageral.component';
import { CustohoramanutencaoComponent } from './pages/integracoes/custos/custohoramanutencao/custohoramanutencao.component';
import { CustoretornoComponent } from './pages/integracoes/custos/custoretorno/custoretorno.component';
import { PainelcustosComponent } from './pages/integracoes/custos/painelcustos/painelcustos.component';
import { FornecedoresComponent } from './pages/integracoes/dadosmestres/fornecedores/fornecedores.component';
import { GruposmateriaisComponent } from './pages/integracoes/dadosmestres/gruposmateriais/gruposmateriais.component';
import { MateriaisComponent } from './pages/integracoes/dadosmestres/materiais/materiais.component';
import { UnidadesmedidasComponent } from './pages/integracoes/dadosmestres/unidadesmedidas/unidadesmedidas.component';
import { MunicipiosComponent } from './pages/integracoes/dadosmestres/municipios/municipios.component';
import { DepositosComponent } from './pages/integracoes/dadosmestres/depositos/depositos.component';
import { EquipamentosComponent } from './pages/integracoes/dadosmestres/equipamentos/equipamentos.component';
import { AdiantamentoComponent } from './pages/integracoes/movimentacao/adiantamento/adiantamento.component';
import { BaixaconsumiveisComponent } from './pages/integracoes/movimentacao/baixaconsumiveis/baixaconsumiveis.component';
import { ClasseAvaliacaoComponent } from './pages/integracoes/movimentacao/classeavaliacao/classeavaliacao.component';
import { ClasseAvaliacaoFormComponent } from './pages/integracoes/movimentacao/classeavaliacao/classeavaliacaoform/classeavaliacaoform.component';
import { TmaComponent } from './pages/integracoes/movimentacao/contratos/tma/tma.component';
import { TmaformComponent } from './pages/integracoes/movimentacao/contratos/tma/tmaform/tmaform.component';
import { DepreciacaoComponent } from './pages/integracoes/movimentacao/depreciacao/depreciacao.component';
import { NotaComponent } from './pages/integracoes/movimentacao/nota/nota.component';
import { NotaformComponent } from './pages/integracoes/movimentacao/nota/notaform/notaform.component';
import { NotaFiscalsComponent } from './pages/integracoes/movimentacao/notafiscals/notafiscals.component';
import { PesagemComponent } from './pages/integracoes/movimentacao/pesagem/pesagem.component';
import { Pesagem91pComponent } from './pages/integracoes/movimentacao/pesagem91p/pesagem91p.component';
import { Pesagem91pFormComponent } from './pages/integracoes/movimentacao/pesagem91p/pesagem91pform/pesagem91pform.component';
import { ProducaosComponent } from './pages/integracoes/movimentacao/producaos/producaos.component';
import { ProvisaoComponent } from './pages/integracoes/movimentacao/provisao/provisao.component';
import { Provisao77pComponent } from './pages/integracoes/movimentacao/provisao77p/provisao77p.component';
import { Provisao77pFormComponent } from './pages/integracoes/movimentacao/provisao77p/provisao77pform/provisao77pform.component';
import { ServicosComponent } from './pages/integracoes/movimentacao/servicos/servicos.component';
import { ParametrizacaoComponent } from './pages/integracoes/parametrizacao/parametrizacao.component';
import { DeposiformComponent } from './pages/painelinsumos/deposito/deposiform/deposiform.component';
import { DepositoComponent } from './pages/painelinsumos/deposito/deposito.component';
import { DetalhesComponent } from './pages/painelinsumos/detalhes/detalhes.component';
import { InsumosExcecaoComponent } from './pages/painelinsumos/insumos-excecao/insumos-excecao.component';
import { InsumosexcecaoformComponent } from './pages/painelinsumos/insumos-excecao/insumosexcecaoform/insumosexcecaoform.component';
import { PainelComponent } from './pages/painelinsumos/painel/painel.component';
import { TransferenciaComponent } from './pages/painelinsumos/transferencia/transferencia.component';
import { ToastService } from './services/toast.service';
import { UsuarioformComponent } from './pages/administracao/usuarios/usuarioform/usuarioform.component';
import { RelatoriosComponent } from './pages/painelinsumos/relatorios/relatorios.component';
import { FuncoesComponent } from './pages/administracao/funcoes/funcoes.component';
import { FuncoesFormComponent } from './pages/administracao/funcoes/funcoes-form/funcoes-form.component';
import {CascadeSelectModule} from "primeng/cascadeselect";
import {ListboxModule} from "primeng/listbox";
import { HasPermissionDirective } from './directives/has-permission.directive';
import {ActionService} from "./services/action.service";
import {ContratosPagamentoComponent} from "./pages/integracoes/contratos/pagamento/pagamento-contrato.component";
import {ContratosNovosComponent} from "./pages/integracoes/contratos/novos/novos.component";
import {ContratosModificadosComponent} from "./pages/integracoes/contratos/modificados/modificados.component";
import {ContratosCanceladosComponent} from "./pages/integracoes/contratos/cancelados/cancelados.component";
import { ContratosIntegradosComponent } from './pages/integracoes/contratos/integrados/contratos-integrados.component';
import { ContratosPendentesCancelamentoComponent } from './pages/integracoes/contratos/pendentes-cancelamento/contratos-pendentes-cancelamento.component';
import {
  ContratosPagamentosNaoIntegradosComponent
} from './pages/integracoes/contratos/pagamentos-nao-integrados/pagamento-nao-integrados.component';
import {ContratosComErrosComponent} from "./pages/integracoes/contratos/com-erros/com-erros.component";
import { ContratosProcessosComponent } from './pages/integracoes/contratos/processos/processos.component';
import { ContratosIntegracaoComponent } from './pages/integracoes/contratos/integracao/contratos-integracao.component';
import {BuscanotafiscalComponent} from "./pages/integracoes/movimentacao/buscanotafiscal/buscanotafiscal.component";
import {FloatLabelModule} from "primeng/floatlabel";
import { ContascontabeisComponent } from './pages/integracoes/dadosmestres/contascontabeis/contascontabeis.component';
import { CentrodecustosComponent } from './pages/integracoes/dadosmestres/centrodecustos/centrodecustos.component';
import { ProCampoComponent } from './pages/producao/analise/campo/procampo.component';
import { ProvariaveisComponent } from './pages/producao/analise/variaveis/provariaveis.component';
import { ProanalisesComponent } from './pages/producao/analise/analises/proanalises.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// Factory function para o APP_INITIALIZER
export function initializePermissions(actionService: ActionService): () => Promise<void> {
  return () => {
    console.log('APP_INITIALIZER: Tentando carregar permissões...'); // Debug
    actionService.loadActions();
    return Promise.resolve();
  };
}

// Provider para o APP_INITIALIZER
export const AppInitializerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializePermissions,
  deps: [ActionService], // Injete o serviço na factory
  multi: true, // Necessário para APP_INITIALIZER
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    MateriaisComponent,
  UnidadesmedidasComponent,
  MunicipiosComponent,
    UnidadesmedidasComponent,
    DepositosComponent,
    EquipamentosComponent,
    FornecedoresComponent,
    ServidoresComponent,
    BasesComponent,
    ClientesComponent,
    NovabaseComponent,
    ClienteformComponent,
    NovoAmbienteDialogComponent,
    ParametrizacaoComponent,
    HeaderComponent,
    BaixaconsumiveisComponent,
    UsuarioComponent,
    PerfilComponent,
    PerfilDialogComponent,
    PerfilformComponent,
    DefinicaoSenhaComponent,
    RedefinicaoSenhaDialogComponent,
    PesagemComponent,
    TagStatusComponent,
    GruposmateriaisComponent,
    DepreciacaoComponent,
    ProducaosComponent,
    NotaFiscalsComponent,
    PainelComponent,
    DepositoComponent,
    DetalhesComponent,
    TransferenciaComponent,
    DeposiformComponent,
    PosicaoDialogComponent,
    NotaComponent,
    NotaformComponent,
    AdiantamentoComponent,
    ProvisaoComponent,
    Provisao77pComponent,
    Provisao77pFormComponent,
    ClasseAvaliacaoComponent,
    ClasseAvaliacaoFormComponent,
    Pesagem91pComponent,
    Pesagem91pFormComponent,
    AtendimentoDialogComponent,
    InsumosExcecaoComponent,
    InsumosexcecaoformComponent,
    ServicosComponent,
    CancelarRemessaComponent,
    TmaComponent,
    TmaformComponent,
    CustodepreciacaoComponent,
    CustodespesageralComponent,
    CustohoramanutencaoComponent,
    CustoconsumoComponent,
    CustoretornoComponent,
    PainelcustosComponent,
    PainelcontratoComponent,
    ContratosComponent,
    ContratoComponent,
    ProcessamentocontratoComponent,
    ListarprocessosComponent,
    TmadialogComponent,
    TmalistComponent,
    UsuariosComponent,
    UsuarioformComponent,
    RelatoriosComponent,
    FuncoesComponent,
    FuncoesFormComponent,
    HasPermissionDirective,
    ContratosPagamentoComponent,
    ContratosNovosComponent,
    ContratosModificadosComponent,
    ContratosCanceladosComponent,
    ContratosIntegradosComponent,
    ContratosPendentesCancelamentoComponent,
    ContratosPagamentosNaoIntegradosComponent,
    ContratosComErrosComponent,
    ContratosProcessosComponent,
    ContratosIntegracaoComponent,
    BuscanotafiscalComponent,
    ContascontabeisComponent,
    CentrodecustosComponent,
    ProCampoComponent,
    ProvariaveisComponent,
    ProanalisesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppLayoutModule,
    CalendarModule,
    CheckboxModule,
    DialogModule,
    DropdownModule,
    MultiSelectModule,
    FieldsetModule,
    InputIconModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    ProgressSpinnerModule,
    OverlayModule,
    ButtonModule,
    RippleModule,
    SplitButtonModule,
    TabViewModule,
    TableModule,
    TagModule,
    ToastModule,
    ToggleButtonModule,
    ToolbarModule,
    TreeModule,
    FormsModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ReactiveFormsModule,
    IconFieldModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CascadeSelectModule,
    ListboxModule,
    FloatLabelModule,

  ],
  exports: [
    ConfirmDialogModule,
    ConfirmPopupModule
  ],
  providers: [ MessageService, ToastService, provideHttpClient(withInterceptors([httpHeaderInterceptor])), AppInitializerProvider],
  bootstrap: [AppComponent],
})
export class AppModule { }
